import React from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import { DATE_FORMAT, TIME_FORMAT } from '../constants';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * Ui date time picker
 * Display the component datetime (react-datetime) in the corresponding mode
 * Props (parameters)
 * @param object(moment) value
 * @param function onChange
 * @param bool input
 * @param bool open
 * @param function isValidDate
 * @param string mode
 */
export default class UiDatetimePicker extends React.PureComponent {
  constructor(props) {
    super(props);
    this.renderDay = this.renderDay.bind(this);
    this.renderMonth = this.renderMonth.bind(this);
    this.renderYear = this.renderYear.bind(this);
  }

  /**
   * Render day
   * @param object props
   * @param MomentObject currentDate
   * @param MomentObject selectedDate
   * @return object
   */
  renderDay(props, currentDate) {
    const { mode } = this.props;
    const style = {};
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      if (props.className.search('Active') > -1) {
        style.color = modeColors.WHITE_COLOR;
        style.backgroundColor =
          modeColors.DATETIME_PICKER_SELECTED_DAY_BACKGROUND_COLOR;
      } else if (props.className.search('Today') > -1) {
        /* used to define the color of the arrow corner located by today */
        style.borderBottomColor =
          modeColors.DATETIME_PICKER_TODAY_CORNER_ARROW_BACKGROUND_COLOR;
      } else {
        style.color = modeColors.TEXT_COLOR;
      }
    }
    return (
      <td {...props} style={style}>
        {currentDate.date()}
      </td>
    );
  }

  /**
   * Render month
   * @param object props
   * @param number month
   * @param number year
   * @param momentObject selectedDate
   */
  renderMonth(props, month) {
    const { mode } = this.props;
    const style = {};
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      if (props.className.search('Active') > -1) {
        style.backgroundColor =
          modeColors.DATETIME_PICKER_SELECTED_DAY_BACKGROUND_COLOR;
        style.color = modeColors.WHITE_COLOR;
      }
    }
    return (
      <td {...props} style={style}>
        {month + 1}
      </td>
    );
  }

  /**
   * Render year
   * @param object props
   * @param number year
   * @param momentObject selectedDate
   */
  renderYear(props, year) {
    const { mode } = this.props;
    const style = {};
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      if (props.className.search('Active') > -1) {
        style.backgroundColor =
          modeColors.DATETIME_PICKER_SELECTED_DAY_BACKGROUND_COLOR;
        style.color = modeColors.WHITE_COLOR;
      }
    }
    return (
      <td {...props} style={style}>
        {year}
      </td>
    );
  }

  render() {
    const {
      value,
      onChange,
      input,
      timeFormat,
      dateFormat,
      open,
      isValidDate,
      mode,
    } = this.props;
    const styleDatetime = {};
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      styleDatetime.borderColor = modeColors.DATETIME_PICKER_BORDER_COLOR;
    }
    return (
      <div style={styleDatetime}>
        <Datetime
          value={value}
          onChange={onChange}
          dateFormat={dateFormat}
          timeFormat={timeFormat}
          input={input}
          open={open}
          isValidDate={isValidDate}
          renderDay={this.renderDay}
          renderMonth={this.renderMonth}
          renderYear={this.renderYear}
          className={`${mode !== null ? 'datetime' : ''}`}
        />
      </div>
    );
  }
}

UiDatetimePicker.propTypes = {
  value: PropTypes.objectOf(Object),
  onChange: PropTypes.func,
  input: PropTypes.bool,
  open: PropTypes.bool,
  isValidDate: PropTypes.func,
  timeFormat: PropTypes.string,
  dateFormat: PropTypes.string,
  mode: PropTypes.string,
};

UiDatetimePicker.defaultProps = {
  value: null,
  onChange: null,
  input: false,
  open: false,
  timeFormat: TIME_FORMAT,
  dateFormat: DATE_FORMAT,
  isValidDate: null,
  mode: null,
};
